import React from 'react'
import './Home.scss'

export default class Home extends React.Component {
  render = () => (
    <div className="home">
      <div className="flex">
        <div className="container">
          <img className="pfp" src="https://cdn.discordapp.com/app-icons/646937666251915264/0e54d87446f106d1fd58385295ae9deb.png?size=256"/>
          <a className="button" href="/support">Discord support server</a><br/>
          <a className="button" href="/invite">Invite Karuta to your server</a>
          <br/>
          <br/>
          <a className="topgg" href="https://top.gg/bot/646937666251915264" >
            <img src="https://top.gg/api/widget/646937666251915264.svg" alt="Karuta" />
          </a>
          <br/>
          <div className="terms">
            <a target="_blank" href="/terms#terms">Terms of Use</a>
            <a target="_blank" href="/terms#privacy">Privacy Policy</a>
            <a target="_blank" href="/terms#payment">Refund Policy</a>
          </div>
        </div>
      </div>
    </div>
  )
}
